export const ellipsis = (str: string, maxLength: number) => {
    let weightedLength = 0;
    let truncatedStr = '';

    for (const char of str) {
        // 한글(유니코드 범위: U+AC00 ~ U+D7A3)일 경우 가중치 2
        weightedLength += /[가-힣]/.test(char) ? 2 : 1;

        if (weightedLength > maxLength) {
            return truncatedStr + '...';
        }
        truncatedStr += char;
    }

    return truncatedStr;
};